import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Table,
  Button,
  Spinner,
  Alert,
} from "reactstrap";
import axios from "axios";
import { API_URL_subproyectos } from "../../constants";
import NewSubproyectoModal from "./NewSubproyectoModal";

const ViewSubproyectosModal = ({ isOpen, toggle, proyectoCode }) => {
  const [subproyectos, setSubproyectos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedSubproyecto, setSelectedSubproyecto] = useState(null);

  const fetchSubproyectos = async () => {
    if (!proyectoCode) return;

    setLoading(true);
    setError("");
    try {
      const response = await axios.get(
        `${API_URL_subproyectos}?proyecto_code=${proyectoCode}`
      );
      setSubproyectos(response.data);
    } catch (err) {
      console.error("Error fetching Subproyectos:", err.response?.data || err.message);
      setError("Error al cargar los subproyectos. Inténtalo nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubproyectos();
  }, [proyectoCode]);

  const handleEdit = (subproyecto) => {
    setSelectedSubproyecto(subproyecto);
  };

  const handleModalClose = () => {
    setSelectedSubproyecto(null);
    fetchSubproyectos();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Detalles de Subproyectos</ModalHeader>
      <ModalBody>
        {loading && (
          <div className="text-center">
            <Spinner color="primary" />
            <p>Cargando subproyectos...</p>
          </div>
        )}
        {error && <Alert color="danger">{error}</Alert>}
        {!loading && !error && (
          <>
            {subproyectos.length > 0 ? (
              <Table bordered>
                <thead>
                  <tr>
                    <th>Código SubProyecto</th>
                    <th>Nombre</th>
                    <th>Fecha Inicio</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {subproyectos
                    .sort((a, b) =>
                      a.subproyecto_code.localeCompare(b.subproyecto_code)
                    )
                    .map((subproyecto) => {
                      return (
                        <tr key={subproyecto.pk}>
                          <td>{subproyecto.subproyecto_code}</td>
                          <td>{subproyecto.proyecto_name || "N/A"}</td>
                          <td>{subproyecto.start_date}</td>
                          <td>
                            <NewSubproyectoModal
                              create={false}
                              proyectoCode={proyectoCode}
                              subproyectoDate={subproyecto.start_date}
                              subproyecto={subproyecto.subproyecto_code}
                              resetState={handleModalClose}
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            ) : (
              <p className="text-muted text-center">
                No hay subproyectos disponibles para este proyecto.
              </p>
            )}
          </>
        )}
        <Button color="secondary" onClick={toggle}>
          Cerrar
        </Button>
      </ModalBody>
    </Modal>
  );
};

export default ViewSubproyectosModal;